(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function uniqueThumbs(images) {
    var seen = {};
    return images.filter(function (img) {
      var src = img.currentSrc || img.src || img.getAttribute('src');
      if (!src || seen[src]) return false;
      seen[src] = true;
      return true;
    });
  }

  function buildVerticalThumbs(wrapper) {
    if (!document.body.classList.contains('template-product')) return;
    if (wrapper.querySelector('.dyu-vertical-thumbs')) return;

    var leftColumn = wrapper.closest('.halo-productView-left');
    var mainNav = wrapper.querySelector('.productView-nav');
    var sourceWrapper = wrapper.querySelector('.productView-thumbnail-wrapper:not(.is-hidden-desktop)');
    if (!leftColumn || !mainNav || !sourceWrapper) return;

    var sourceImages = uniqueThumbs(Array.prototype.slice.call(sourceWrapper.querySelectorAll('.productView-thumbnail:not(.slick-cloned) img')));
    if (!sourceImages.length) return;

    var rail = document.createElement('div');
    rail.className = 'dyu-vertical-thumbs';
    rail.setAttribute('aria-label', 'Product images');

    sourceImages.forEach(function (img, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'dyu-vertical-thumbs__item';
      button.setAttribute('aria-label', 'View product image ' + (index + 1));
      button.dataset.dyuThumbIndex = String(index);

      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.alt = img.alt || '';
      clone.loading = 'lazy';
      button.appendChild(clone);

      button.addEventListener('click', function () {
        goTo(index);
      });

      rail.appendChild(button);
    });

    wrapper.insertBefore(rail, wrapper.firstElementChild);
    wrapper.classList.add('has-dyu-vertical-thumbs');
    leftColumn.classList.add('dyu-gallery-left');

    function setActive(index) {
      Array.prototype.forEach.call(rail.querySelectorAll('.dyu-vertical-thumbs__item'), function (button) {
        var active = Number(button.dataset.dyuThumbIndex) === Number(index);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      setActive(index);
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        var main = window.jQuery(mainNav);
        if (main.hasClass('slick-initialized')) main.slick('slickGoTo', index);
        var originalThumbs = window.jQuery(sourceWrapper).find('.productView-for');
        if (originalThumbs.hasClass('slick-initialized')) originalThumbs.slick('slickGoTo', index);
      }
    }

    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      var main = window.jQuery(mainNav);
      main.off('afterChange.dyuVerticalThumbs').on('afterChange.dyuVerticalThumbs', function (_event, _slick, currentSlide) {
        setActive(currentSlide || 0);
      });
      if (main.hasClass('slick-initialized')) {
        setActive(main.slick('slickCurrentSlide') || 0);
      } else {
        setActive(0);
      }
    } else {
      setActive(0);
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.productView-images-wrapper'), buildVerticalThumbs);
  }

  ready(function () {
    init();
    window.setTimeout(init, 600);
    window.setTimeout(init, 1800);
  });
})();
